import { FC, useCallback, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { GridActionsCellItem, GridRowParams } from '@mui/x-data-grid';
import { Delete, Visibility } from '@mui/icons-material';

import { Jobseeker } from '@libs/models';
import { useJobseekerAdminSearchQuery } from '@carcareers/store';
import { useJobseeker } from '@carcareers/hooks';
import { DashboardPageContainer, DataGridV2 as DataGrid } from '@carcareers/components';
import { routes, useIsMobile } from '@carcareers/utils';
import {
  JOBSEEKER_INDEX_COLUMNS,
  JOBSEEKER_INDEX_COLUMN_INITIAL_STATE,
  JOBSEEKER_INDEX_COLUMNS_INITIAL_STATE_MOBILE,
} from '@carcareers/utils';

export const JobseekerIndex: FC = () => {
  const navigate = useNavigate();
  const { deleteJobseeker } = useJobseeker();
  const search = useJobseekerAdminSearchQuery;
  const isMobile = useIsMobile();

  const columns = [
    ...JOBSEEKER_INDEX_COLUMNS,
    {
      field: 'actions',
      type: 'actions' as const,
      flex: 1,
      align: 'right' as const,
      headerAlign: 'right' as const,
      getActions: (params: GridRowParams) => [
        <GridActionsCellItem
          showInMenu
          key={`view-${params.row.id}`}
          label="View"
          icon={<Visibility />}
          onClick={() =>
            navigate(`/${routes.ADMIN_HOME}/${routes.ADMIN_JOBSEEKERS_VIEW.replace(':id', params.row.id.toString())}`)
          }
        />,
        <GridActionsCellItem
          showInMenu
          key={`delete-${params.row.id}`}
          label="Delete"
          icon={<Delete color="error" />}
          onClick={() => deleteJobseeker(params.row.id)}
        />,
      ],
    },
  ];

  return (
    <DashboardPageContainer sx={{ pb: 2 }}>
      <DataGrid<Jobseeker>
        query={search}
        columns={columns}
        initialState={{
          columns: {
            columnVisibilityModel: isMobile
              ? JOBSEEKER_INDEX_COLUMNS_INITIAL_STATE_MOBILE
              : JOBSEEKER_INDEX_COLUMN_INITIAL_STATE,
          },
        }}
      />
    </DashboardPageContainer>
  );
};

export default JobseekerIndex;
